import React from "react";
import { Phone, MessageCircle } from "lucide-react";
import { heroData } from "../data/mock";

const FloatingCTA = () => {
  const handleCall = () => {
    window.open(`tel:${heroData.phone}`, "_self");
  };

  const handleWhatsApp = () => {
    const message = encodeURIComponent(
      "Hello! I would like to book a cab with Bahubali Cabs."
    );
    window.open(
      `https://wa.me/${heroData.whatsapp}?text=${message}`,
      "_blank"
    );
  };

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[60] md:hidden pb-[env(safe-area-inset-bottom)]">
      <div className="flex items-center gap-3 bg-white/95 backdrop-blur-xl border border-white/60 rounded-full px-3 py-3 shadow-2xl">
        {/* Call CTA */}
        <button
          onClick={handleCall}
          aria-label="Call Bahubali Cabs"
          className="
            flex items-center gap-2
            bg-gradient-to-r from-amber-500 to-amber-600
            text-white
            px-6 py-3
            rounded-full
            shadow-lg
            hover:shadow-xl
            transition-all duration-300
            active:scale-95
          "
        >
          <Phone className="w-5 h-5" />
          <span className="font-semibold text-base">Call Now</span>
        </button>

        {/* WhatsApp CTA */}
        <button
          onClick={handleWhatsApp}
          aria-label="Chat on WhatsApp with Bahubali Cabs"
          className="
            relative
            flex items-center gap-2
            bg-emerald-500 hover:bg-emerald-600
            text-white
            px-6 py-3
            rounded-full
            shadow-lg
            hover:shadow-xl
            transition-all duration-300
            active:scale-95
          "
        >
          {/* Soft Pulse Indicator */}
          <span className="absolute -top-1 -right-1 w-3 h-3 bg-emerald-300 rounded-full animate-ping opacity-50" />
          <span className="absolute -top-1 -right-1 w-3 h-3 bg-emerald-400 rounded-full" />

          <MessageCircle className="w-5 h-5" />
          <span className="font-semibold text-base">WhatsApp</span>
        </button>
      </div>
    </div>
  );
};

export default FloatingCTA;
